import { render, staticRenderFns } from "./SMRDetaile.vue?vue&type=template&id=3671281c&scoped=true&"
import script from "./SMRDetaile.vue?vue&type=script&lang=js&"
export * from "./SMRDetaile.vue?vue&type=script&lang=js&"
import style0 from "./SMRDetaile.vue?vue&type=style&index=0&id=3671281c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3671281c",
  null
  
)

export default component.exports